import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Radio as AriaRadio, RadioGroup as AriaRadioGroup } from "react-aria-components";
import { item, radioGroup, wrapper } from "./RadioGroup.css.js";
import { jsx as _jsx } from "react/jsx-runtime";
const RadioGroupItemStyleContext = /*#__PURE__*/React.createContext({
  type: "buttonWhite",
  size: "m"
});
export function RadioGroup(t0) {
  const $ = _c(17);
  let children;
  let rest;
  let size;
  let type;
  if ($[0] !== t0) {
    ({
      children,
      type,
      size,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
    $[3] = size;
    $[4] = type;
  } else {
    children = $[1];
    rest = $[2];
    size = $[3];
    type = $[4];
  }
  let t1;
  if ($[5] !== size || $[6] !== type) {
    t1 = {
      type,
      size
    };
    $[5] = size;
    $[6] = type;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const providerValue = t1;
  let t2;
  if ($[8] !== type) {
    t2 = radioGroup({
      type
    });
    $[8] = type;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== rest || $[12] !== t2) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: wrapper,
      children: /*#__PURE__*/_jsx(AriaRadioGroup, {
        ...rest,
        className: t2,
        children: children
      })
    });
    $[10] = children;
    $[11] = rest;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== providerValue || $[15] !== t3) {
    t4 = /*#__PURE__*/_jsx(RadioGroupItemStyleContext.Provider, {
      value: providerValue,
      children: t3
    });
    $[14] = providerValue;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
function BaseRadioGroupItem(t0, ref) {
  const $ = _c(11);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  const {
    type,
    size
  } = React.useContext(RadioGroupItemStyleContext);
  let t1;
  if ($[3] !== size || $[4] !== type) {
    t1 = item({
      type,
      size
    });
    $[3] = size;
    $[4] = type;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== ref || $[8] !== rest || $[9] !== t1) {
    t2 = /*#__PURE__*/_jsx(AriaRadio, {
      ...rest,
      className: t1,
      ref: ref,
      children: children
    });
    $[6] = children;
    $[7] = ref;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
const ReffedBaseRadioGroupItem = /*#__PURE__*/React.forwardRef(BaseRadioGroupItem);
export const RadioGroupItem = /*#__PURE__*/React.memo(ReffedBaseRadioGroupItem);
//# sourceMappingURL=RadioGroup.js.map